<footer class="relative">
    <svg class="absolute top-0 left-[calc(50%-94px)] z-[1]" width="188" height="305" viewBox="0 0 188 305" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.56331 233.852C-1.52078 227.768 -1.52134 217.903 4.56262 211.819C10.6468 205.735 20.512 205.735 26.5962 211.819L60.1085 245.331C59.404 196.699 58.5223 132.059 58.5223 116.115C58.5223 87.8926 77.5839 74.6497 90.117 71.9637L90.8352 71.8104L91.5609 71.7241C99.8594 70.7478 121.591 68.8632 144.332 68.8632C147.615 68.8632 149.601 68.1964 150.787 67.585C151.985 66.967 152.927 66.114 153.721 65.0107C155.536 62.4904 156.293 58.9993 156.293 56.9024V-22.9661C156.293 -31.5704 163.269 -38.5466 171.873 -38.5466C180.478 -38.5463 187.454 -31.5702 187.454 -22.9661L187.453 56.9017C187.453 63.985 185.456 74.2645 179.008 83.2194C171.989 92.9683 160.426 100.023 144.332 100.023C124.042 100.023 104.499 101.648 96.3567 102.546C96.1522 102.63 95.8544 102.764 95.4914 102.975C94.7295 103.418 93.8597 104.081 93.0449 105.01C91.6103 106.645 89.6834 109.844 89.6834 116.115C89.6834 131.681 90.5434 195.092 91.244 243.563L131.25 203.557C137.334 197.473 147.199 197.473 153.284 203.557C159.368 209.641 159.367 219.505 153.283 225.59L74.792 304.08L4.56331 233.852Z"
            fill="#F15928" />
    </svg>
    
    <div class="w-screen bg-secondary mt-[50px] pt-5 md:pt-[57px] px-5 md:pl-[77px] pb-[80px] md:flex md:place-content-between relative">
        <div class="md:w-[431px] z-[3] relative">
            <div class="flex items-center gap-[11px]">
                <img (click)="null" class="cursor-pointer w-[60px] h-[60px] object-contain" src="../../assets/logosos.png" alt="Innovation Plaza">
                <div class="font-bold text-font20px text-white">Innovation-Plaza s.r.l</div>
            </div>

            <div class="flex items-center gap-5 mt-6 mb-8">
                <a href="https://www.facebook.com/people/Innovation-Plaza/61556155897173/" target="_blank" rel="noopener noreferrer" class="hover:scale-110 transition-transform">
                    <img src="../../assets/logoFacebook.png" alt="Facebook" class="w-12 h-12 object-contain">
                </a>
                <a href="https://www.linkedin.com/company/innovation-plaza-s-r-l/?originalSubdomain=it" target="_blank" rel="noopener noreferrer" class="hover:scale-110 transition-transform">
                    <img src="../../assets/logoLinkedin.png" alt="Linkedin" class="w-10 h-10 object-contain">
                </a>
            </div>

            <div class="text-white text-font40px leading-[42px] font-bold">
                UN SOLO SPAZIO. TUTTE LE RISORSE PER CHI VUOLE INNOVARE
            </div>

            <div (click)="goTo('cerca-bando')"
                class="text-white cursor-pointer mt-[35px] bg-quintary w-[225px] h-[47px] flex items-center place-content-center text-font24px font-bold rounded-full">
                Scopri i Bandi
            </div>
        </div>

        <div class="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-6 z-[3]">
            <a href="../../assets/Condizioni_Generali_di_Contratto-DEF..pdf?v=1.0" target="_blank" class="text-white opacity-50 text-font16px underline hover:opacity-100">
                Termini & Condizioni
            </a>
            <a href="../../assets/INFORMATIVA PRIVACY_DEF.pdf" target="_blank" class="text-white opacity-50 text-font16px underline hover:opacity-100">
                Privacy & Policy
            </a>
        </div>

        <div class="md:w-[365px] mt-5 md:mt-0 text-white z-[1]">
            <div class="text-font24px font-bold">Sede legale</div>
            <div class="text-font20px">Viale Papiniano 44,<br>
                Milano — Italia<br>
                20123</div>
            <div class="text-font24px font-bold mt-[46px]">Sedi operative</div>
            <div class="text-font20px">Cinisello Balsamo (Ml)<br>
                Brindisi (BR)</div>
            <div class="text-font24px font-bold mt-[46px]">Contatti</div>
            <div class="text-font20px">+39 02 49539 510<br>
                {{'info@innovationplaza.it'}}</div>
        </div>
    </div>

    <div class="h-fit py-4 bg-[#D3E0FF] px-2.5 text-[#0A0045] font-medium text-font16px md:text-font24px">
        <div class="text-center">Intervento cofinanziato dall’U.E. a valere sul PR Puglia FESR-FSE+ 2021-2027 FONDO TECNONIDI</div>
        <img class="mx-auto py-4 h-fit w-fit md:h-[100px]" src="../../assets/loghi_fascia.png">
        <div class="text-center">© 2026 Innovation-Plaza s.r.l. — Tutti i diritti sono riservati</div>
    </div>
</footer>